import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./en";
import fr from "./fr";

export const locales = { en, fr };

// Change this to "fr" to run the whole study in French again.
export const DEFAULT_LOCALE = "en";

const LanguageContext = createContext({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
  t: locales[DEFAULT_LOCALE],
});

export function LanguageProvider({ children, initialLocale = DEFAULT_LOCALE }) {
  const [locale, setLocale] = useState(
    locales[initialLocale] ? initialLocale : DEFAULT_LOCALE
  );

  const t = locales[locale] || locales[DEFAULT_LOCALE];

  useEffect(() => {
    document.documentElement.lang = locale;
    document.title = t.documentTitle;
  }, [locale, t]);

  const value = useMemo(() => ({ locale, setLocale, t }), [locale, t]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

// Returns the dictionary for the active locale.
export function useT() {
  return useContext(LanguageContext).t;
}

// Returns { locale, setLocale, t } for components that need to switch language.
export function useLanguage() {
  return useContext(LanguageContext);
}
